import React, { useEffect, useState } from 'react'
import { apiPost } from '../../utils/apiFetch'
import apiPath from '../../utils/pathObj'
import { useForm } from 'react-hook-form'
import ErrorMessage from '../../components/ErrorMessage'
import useToastContext from 'hooks/useToastContext'
import { validationRules } from 'utils/constants'
import { validateFile } from 'utils/reusableMethods'
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai'
import FormData from 'form-data'
import { useTranslation } from 'react-i18next'
import OInputField from 'components/reusable/OInputField'
import { preventMax } from 'utils/validations'
import formValidation from '../../utils/formValidation'
import { isEmpty } from 'lodash'

const UserAdd = ({ setShowModal, getAllUser, setPage }) => {
  const { t } = useTranslation()
  const notification = useToastContext()
  const {
    register,
    handleSubmit,
    watch,
    getValues,
    trigger,
    setError,
    clearErrors,
    formState: { errors }
  } = useForm({ mode: 'onChange', shouldFocusError: true, defaultValues: {} })

  const [addMerchantLoading, setAddMerchantLoading] = useState(false)
  const [cat, setCat] = useState('individual')
  const [icon, setIcon] = useState(true)
  const [passwordIcon, setPasswordIcon] = useState(true)
  const [fileErrors, setFileErrors] = useState({
    identityCardFront: '',
    passport: '',
    identityCardBack: '',
    businessExtract: '',
    businessLicense: '',
    profile_pic: ''
  })

  useEffect(() => {
    if (watch('identityCardFront')?.length > 0) {
      const identityCardMsg = validateFile(watch('identityCardFront')[0])
      const fileSize = (watch('identityCardFront')[0].size / 1048576).toFixed(2)
      if (identityCardMsg) {
        setFileErrors({
          ...fileErrors,
          identityCardFront: identityCardMsg
        })
      } else if (fileSize > 3) {
        setFileErrors({
          ...fileErrors,
          identityCardFront: t('FILE_SIZE_ERROR')
        })
      } else {
        setFileErrors({
          ...fileErrors,
          identityCardFront: ''
        })
      }
    }
  }, [watch('identityCardFront')])

  useEffect(() => {
    if (watch('identityCardBack')?.length > 0) {
      const identityCardMsg = validateFile(watch('identityCardBack')[0])
      const fileSize = (watch('identityCardBack')[0].size / 1048576).toFixed(2)
      if (identityCardMsg) {
        setFileErrors({
          ...fileErrors,
          identityCardBack: identityCardMsg
        })
      } else if (fileSize > 3) {
        setFileErrors({
          ...fileErrors,
          identityCardBack: t('FILE_SIZE_ERROR')
        })
      } else {
        setFileErrors({
          ...fileErrors,
          identityCardBack: ''
        })
      }
    }
  }, [watch('identityCardBack')])

  // useEffect(() => {
  //   if (watch('businessExtract')?.length > 0) {
  //     const identityCardMsg = validateFile(watch('businessExtract')[0])
  //     const fileSize = (watch('businessExtract')[0].size / 1048576).toFixed(2)
  //     if (identityCardMsg) {
  //       setFileErrors({
  //         ...fileErrors,
  //         businessExtract: identityCardMsg
  //       })
  //     } else if (fileSize > 3) {
  //       setFileErrors({
  //         ...fileErrors,
  //         businessExtract: t('FILE_SIZE_ERROR')
  //       })
  //     } else {
  //       setFileErrors({
  //         ...fileErrors,
  //         businessExtract: ''
  //       })
  //     }
  //   }
  // }, [watch('businessExtract')])

  // useEffect(() => {
  //   if (watch('businessLicense')?.length > 0) {
  //     const identityCardMsg = validateFile(watch('businessLicense')[0])
  //     const fileSize = (watch('businessLicense')[0].size / 1048576).toFixed(2)
  //     if (identityCardMsg) {
  //       setFileErrors({
  //         ...fileErrors,
  //         businessLicense: identityCardMsg
  //       })
  //     } else if (fileSize > 3) {
  //       setFileErrors({
  //         ...fileErrors,
  //         businessLicense: t('FILE_SIZE_ERROR')
  //       })
  //     } else {
  //       setFileErrors({
  //         ...fileErrors,
  //         businessLicense: ''
  //       })
  //     }
  //   }
  // }, [watch('businessLicense')])

  useEffect(() => {
    if (watch('profile_pic')?.length > 0) {
      const identityCardMsg = validateFile(watch('profile_pic')[0])
      const fileSize = (watch('profile_pic')[0].size / 1048576).toFixed(2)
      if (identityCardMsg) {
        setFileErrors({
          ...fileErrors,
          profile_pic: identityCardMsg
        })
      } else if (fileSize > 3) {
        setFileErrors({
          ...fileErrors,
          profile_pic: t('FILE_SIZE_ERROR')
        })
      } else {
        setFileErrors({
          ...fileErrors,
          profile_pic: ''
        })
      }
    }
  }, [watch('profile_pic')])

  useEffect(() => {
    if (watch('passport')?.length > 0) {
      const passportMsg = validateFile(watch('passport')[0])
      const fileSize = (watch('passport')[0].size / 1048576).toFixed(2)
      if (passportMsg) {
        setFileErrors({
          ...fileErrors,
          passport: passportMsg
        })
      } else if (fileSize > 3) {
        setFileErrors({
          ...fileErrors,
          passport: t('FILE_SIZE_ERROR')
        })
      } else {
        setFileErrors({
          ...fileErrors,
          passport: ''
        })
      }
    }
  }, [watch('passport')])

  const handleSubmitForm = async data => {
    try {
      if (
        cat === 'business' &&
        (fileErrors.identityCardFront ||
          fileErrors.identityCardBack ||
          fileErrors.businessLicense ||
          fileErrors.businessExtract)
      ) {
        return
      } else if (
        (cat === 'individual' && fileErrors.identityCardFront) ||
        fileErrors.identityCardBack
      ) {
        return
      }
      setAddMerchantLoading(true)
      const formData = new FormData()

      if (cat === 'business') {
        formData.append('identityCardFront', data.identityCardFront[0])
        formData.append('identityCardBack', data.identityCardBack[0])
        formData.append('businessLicense', data.businessLicense[0])
        formData.append('businessExtract', data.businessExtract[0])
      }
      if (cat === 'individual') {
        formData.append('identityCardFront', data.identityCardFront[0])
        formData.append('identityCardBack', data.identityCardBack[0])
      }
      formData.append('niptNo', data.niptNo)
      formData.append('profile_pic', data.profile_pic[0])
      formData.append('first_name', data.first_name)
      formData.append('userType', cat)
      formData.append('last_name', data.last_name)
      formData.append('username', data.username)
      formData.append('mobile', data.mobile)
      formData.append('country_code', data.country_code || 355)
      formData.append('email', data.email)
      formData.append('password', data.password)
      formData.append('refCode', data.refCode)
      formData.append('businessName', data.businessName)

      const res = await apiPost(apiPath.createUser, formData)
      if (res.data.success === true) {
        setPage(1)
        getAllUser()
        setShowModal(false)
        notification.success(res.data.message)
      } else {
        notification.error(res?.data?.message)
      }
    } catch (err) {
      console.log('err:', err)
    } finally {
      setAddMerchantLoading(false)
    }
  }
  function changeIcon () {
    setIcon(!icon)
  }
  function changePasswordIcon () {
    setPasswordIcon(!passwordIcon)
  }

  const password = watch('password')
  useEffect(() => {
    if (!isEmpty(password)) {
      trigger('confirm_password')
    }
  }, [password, trigger])

  const selectCategory = e => {
    if (e.target.value) {
      setCat(e.target.value)
      clearErrors('category_id')
    } else {
      setCat('')
      setError('category_id', {
        type: 'validation',
        message: t('PLEASE_SELECT_CATEGORY')
      })
    }
  }

  const codeValue = watch('email') ? watch('email') : ''

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto'>
          <div
            className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none w-[1000px]'
            style={{ maxHeight: '80vh', overflowY: 'auto' }}
          >
            <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
              <h3 className='text-xl font-semibold'>{t('USERS_ADD_USER')}</h3>
              <button
                className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                onClick={() => setShowModal(false)}
              >
                <span className=' text-[#B8BBBF]  text-4xl ' title={t('CLOSE')}>
                  ×
                </span>
              </button>
            </div>
            <form onSubmit={handleSubmit(handleSubmitForm)} method='post'>
              <div className='relative p-6 flex-auto'>
                <div className='grid sm:grid-cols-3'>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <OInputField
                      wrapperClassName='relative z-0  w-full group'
                      name='first_name'
                      inputLabel={
                        <>
                          {t('O_FIRST_NAME')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      autoFocus
                      maxLength={15}
                      onInput={e => preventMax(e, 15)}
                      register={register(
                        'first_name',
                        formValidation['first_name']
                      )}
                      errors={errors}
                    />
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='last_name'
                      inputLabel={
                        <>
                          {t('O_LAST_NAME')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      maxLength={15}
                      onInput={e => preventMax(e, 15)}
                      register={register(
                        'last_name',
                        formValidation['last_name']
                      )}
                      errors={errors}
                    />
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='username'
                      inputLabel={
                        <>
                          {t('O_USERNAME')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      maxLength={15}
                      onInput={e => preventMax(e, 15)}
                      register={register(
                        'username',
                        formValidation['username']
                      )}
                      errors={errors}
                    />
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='country_code'
                      inputLabel={<>{t('O_COUNTRY_CODE')}</>}
                      errors={errors}
                      type='select'
                      register={register('country_code', {})}
                      selectOptions={[
                        <option value='355' key='355'>
                          +355
                        </option>
                      ]}
                    />
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      type='number'
                      name='mobile'
                      id='mobile'
                      inputLabel={
                        <>
                          {t('O_MOBILE_NUMBER')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      min={0}
                      onKeyDown={e => {
                        if (['-', '+', 'e'].includes(e.key)) {
                          e.preventDefault()
                        }
                      }}
                      onInput={e => preventMax(e, 9)}
                      register={register('mobile', formValidation['mobile'])}
                      errors={errors}
                    />
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      type='text'
                      name='email'
                      id='email'
                      value={codeValue.toLowerCase()}
                      inputLabel={
                        <>
                          {t('O_EMAIL')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      maxLength={50}
                      autoComplete='off'
                      onInput={e => preventMax(e, 50)}
                      register={register('email', formValidation['email'])}
                      errors={errors}
                    />
                  </div>

                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      type='text'
                      name='refCode'
                      id='refCode'
                      inputLabel={<>{t('USERS_REFERRAL_CODE')}</>}
                      maxLength={40}
                      onInput={e => preventMax(e, 50)}
                      register={register('refCode', formValidation['refCode'])}
                      errors={errors}
                    />
                  </div>

                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                      <OInputField
                        wrapperClassName='relative z-0   w-full group'
                        type={icon ? 'password' : 'text'}
                        name='password'
                        inputLabel={
                          <>
                            {t('O_PASSWORD')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        errors={errors}
                        maxLength={15}
                        onInput={e => preventMax(e, 15)}
                        register={register('password', {
                          required: t('PLEASE_ENTER_PASSWORD'),
                          pattern: {
                            value: validationRules.password,
                            message: validationRules.passwordMessage
                          }
                        })}
                      />
                      {icon ? (
                        <span
                          className='password_view absolute top-[18px] right-[20px]'
                          onClick={() => changeIcon()}
                        >
                          <AiFillEyeInvisible />
                        </span>
                      ) : (
                        <span
                          className='password_view absolute top-[18px] right-[20px]'
                          onClick={() => changeIcon()}
                        >
                          <AiFillEye />
                        </span>
                      )}
                    </div>
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                      <OInputField
                        wrapperClassName='relative z-0   w-full group'
                        type={passwordIcon ? 'password' : 'text'}
                        inputLabel={
                          <>
                            {t('O_CONFIRM_PASSWORD')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        name='confirm_password'
                        id='confirm_password'
                        autoComplete='new-password'
                        maxLength={15}
                        errors={errors}
                        onInput={e => preventMax(e, 15)}
                        register={register('confirm_password', {
                          required: t('PLEASE_ENTER_CONFIRM_PASSWORD'),
                          pattern: {
                            value: validationRules.password,
                            message: validationRules.confirmPasswordMessage
                          },
                          validate: value => {
                            const { password } = getValues()
                            return (
                              password === value ||
                              t('PASSWORD_AND_CONFIRM_PASSWORD_DOES_NOT_MATCH')
                            )
                          }
                        })}
                      />
                      {passwordIcon ? (
                        <span
                          className='password_view absolute top-[18px] right-[20px]'
                          onClick={() => changePasswordIcon()}
                        >
                          <AiFillEyeInvisible />
                        </span>
                      ) : (
                        <span
                          className='password_view absolute top-[18px] right-[20px]'
                          onClick={() => changePasswordIcon()}
                        >
                          <AiFillEye />
                        </span>
                      )}
                    </div>
                  </div>

                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                      <select
                        type='select'
                        id='role'
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                        placeholder=' '
                        value={cat}
                        {...register('role', {
                          required: t('PLEASE_SELECT_USER_TYPE')
                        })}
                        onChange={selectCategory}
                      >
                        <option value='individual'>{t('O_INDIVIDUAL')}</option>
                        <option value='business'>{t('BUSINESS')}</option>
                      </select>
                      <label
                        htmlFor='category'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {' '}
                        {t('USER_TYPE')}
                        <span className='text-red-500'>*</span>
                      </label>
                      <ErrorMessage message={errors?.role?.message} />
                    </div>
                  </div>

                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                      <div className='block py-3 h-14 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none  focus:outline-none focus:ring-0  peer'>
                        <input
                          type='file'
                          name='profile_pic'
                          style={{ width: '100%' }}
                          placeholder='Identity Card '
                          className='form-control'
                          accept='image/png,image/jpeg,image/jpg'
                          {...register('profile_pic', {
                            required: t('PLEASE_UPLOAD_PICTURE')
                          })}
                        />
                      </div>
                      <label
                        for='floating_file'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-1 left-0 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('PROFILE_PICTURE')}
                        <span className='text-red-500'>*</span>
                      </label>
                      <ErrorMessage
                        message={
                          errors?.profile_pic?.message || fileErrors.profile_pic
                        }
                      />
                    </div>
                  </div>

                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                      <OInputField
                        wrapperClassName='relative z-0   w-full group'
                        type='text'
                        name='niptNo'
                        id='niptNo'
                        inputLabel={
                          <>
                            NID / NIPT
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        maxLength={40}
                        onInput={e => preventMax(e, 50)}
                        register={register('niptNo', formValidation['niptNo'])}
                        errors={errors}
                      />
                    </div>

                  {cat === 'individual' ? (
                    <>
                      <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                        <div className='relative z-0   w-full group'>
                          <div className='block py-3 h-14 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none  focus:outline-none focus:ring-0  peer'>
                            <input
                              type='file'
                              name='identityCardFront'
                              placeholder='Identity Card '
                              className='form-control'
                              style={{ width: '100%' }}
                              accept='image/png,image/jpeg,image/jpg'
                              {...register('identityCardFront', {
                                required: t(
                                  'PLEASE_POROVIDE_FRONT_SIDE_OF_IDENTITY_CARD'
                                )
                              })}
                            />
                          </div>
                          <label
                            for='floating_file'
                            className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-1 left-0 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                          >
                            {t('O_IDENTITY_CARD_FRONT')}
                            <span className='text-red-500'>*</span>
                          </label>
                          <ErrorMessage
                            message={
                              errors?.identityCardFront?.message ||
                              fileErrors.identityCardFront
                            }
                          />
                        </div>
                      </div>

                      <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                        <div className='relative z-0   w-full group'>
                          <div className='block py-3 h-14 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none  focus:outline-none focus:ring-0  peer'>
                            <input
                              type='file'
                              name='identityCardBack'
                              placeholder='Identity Card '
                              style={{ width: '100%' }}
                              className='form-control'
                              accept='image/png,image/jpeg,image/jpg'
                              {...register('identityCardBack', {
                                required: t(
                                  'PLEASE_POROVIDE_BACK_SIDE_OF_IDENTITY_CARD'
                                )
                              })}
                            />
                          </div>
                          <label
                            for='floating_file'
                            className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-1 left-0 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                          >
                            {t('O_IDENTITY_CARD_BACK')}
                            <span className='text-red-500'>*</span>
                          </label>
                          <ErrorMessage
                            message={
                              errors?.identityCardBack?.message ||
                              fileErrors.identityCardBack
                            }
                          />
                        </div>
                      </div>
                    </>
                  ) : cat === 'business' ? (
                    <>
                      
                      <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                        <OInputField
                          wrapperClassName='relative z-0   w-full group'
                          name='businessName'
                          inputLabel={
                            <>
                              {t('O_BUSINESS_NAME')}
                              <span className='text-red-500'>*</span>
                            </>
                          }
                          type='text'
                          maxLength={15}
                          onInput={e => preventMax(e, 15)}
                          register={register(
                            'businessName',
                            formValidation['business_name']
                          )}
                          errors={errors}
                        />
                      </div>

                      <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                        <div className='relative z-0   w-full group'>
                          <div className='block py-3 h-14 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none  focus:outline-none focus:ring-0  peer'>
                            <input
                              type='file'
                              name='identityCardFront'
                              placeholder='Identity Card '
                              style={{ width: '100%' }}
                              className='form-control'
                              accept='image/png,image/jpeg,image/jpg'
                              {...register('identityCardFront', {
                                required: t(
                                  'PLEASE_POROVIDE_FRONT_SIDE_OF_IDENTITY_CARD'
                                )
                              })}
                            />
                          </div>
                          <label
                            for='floating_file'
                            className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-1 left-0 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                          >
                            {t('O_IDENTITY_CARD_FRONT')}
                            <span className='text-red-500'>*</span>
                          </label>
                          <ErrorMessage
                            message={
                              errors?.identityCardFront?.message ||
                              fileErrors.identityCardFront
                            }
                          />
                        </div>
                      </div>
                      <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                        <div className='relative z-0   w-full group'>
                          <div className='block py-3 h-14 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none  focus:outline-none focus:ring-0  peer'>
                            <input
                              type='file'
                              name='identityCardBack'
                              placeholder='Identity Card '
                              style={{ width: '100%' }}
                              className='form-control'
                              accept='image/png,image/jpeg,image/jpg'
                              {...register('identityCardBack', {
                                required: t(
                                  'PLEASE_POROVIDE_BACK_SIDE_OF_IDENTITY_CARD'
                                )
                              })}
                            />
                          </div>
                          <label
                            for='floating_file'
                            className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-1 left-0 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                          >
                            {t('O_IDENTITY_CARD_BACK')}
                            <span className='text-red-500'>*</span>
                          </label>
                          <ErrorMessage
                            message={
                              errors?.identityCardBack?.message ||
                              fileErrors.identityCardBack
                            }
                          />
                        </div>
                      </div>
                      <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                        <div className='relative z-0   w-full group'>
                          <div className='block py-3 h-14 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none  focus:outline-none focus:ring-0  peer'>
                            <input
                              type='file'
                              name='businessExtract'
                              placeholder='Identity Card '
                              style={{ width: '100%' }}
                              className='form-control'
                              accept='application/pdf'
                              {...register('businessExtract', {
                                required: t('PLEASE_UPLOAD_BUSINESS_EXTRACT')
                              })}
                            />
                          </div>
                          <label
                            for='floating_file'
                            className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-1 left-0 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                          >
                            {t('O_BUSINESS_EXTRACT')}
                            <span className='text-red-500'>*</span>
                          </label>
                          <ErrorMessage
                            message={
                              errors?.businessExtract?.message ||
                              fileErrors.businessExtract
                            }
                          />
                        </div>
                      </div>
                      <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                        <div className='relative z-0   w-full group'>
                          <div className='block py-3 h-14 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none  focus:outline-none focus:ring-0  peer'>
                            <input
                              type='file'
                              name='businessLicense'
                              placeholder='Identity Card '
                              style={{ width: '100%' }}
                              className='form-control'
                              accept="application/pdf"
                              {...register('businessLicense', {
                                required: t('PLEASE_UPLOAD_BUSINESS_LICENSE')
                              })}
                            />
                          </div>
                          <label
                            for='floating_file'
                            className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-1 left-0 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                          >
                            {t('O_BUSINESS_LICENSE_ONLY')}
                            <span className='text-red-500'>*</span>
                          </label>
                          <ErrorMessage
                            message={
                              errors?.businessLicense?.message ||
                              fileErrors.businessLicense
                            }
                          />
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='text-black bg-[#E1E1E1] font-normal   px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => setShowModal(false)}
                >
                  {t('O_BACK')}
                </button>

                {addMerchantLoading ? (
                  <div className='spinner-container bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'>
                    <div className='loading-spinner'></div>
                  </div>
                ) : (
                  <button
                    className={` bg-LightBlue cursor-pointer  text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150`}
                    type='submit'
                  >
                    {t('O_ADD')}
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default UserAdd
